import { render, staticRenderFns } from "./Exhibition1.vue?vue&type=template&id=0e039b65&scoped=true"
import script from "./Exhibition1.vue?vue&type=script&lang=js"
export * from "./Exhibition1.vue?vue&type=script&lang=js"
import style0 from "./Exhibition1.vue?vue&type=style&index=0&id=0e039b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e039b65",
  null
  
)

export default component.exports